export const SHADOW = {
  NORMAL: '--shadow-normal',
  HUGE: '--shadow-huge',
  CARD: '--shadow-card',
  TOAST: '--shadow-toast',
} as const
export type SHADOW = (typeof SHADOW)[keyof typeof SHADOW]
